import script from "./ListNews.vue?vue&type=script&setup=true&lang=js"
export * from "./ListNews.vue?vue&type=script&setup=true&lang=js"

import "./ListNews.vue?vue&type=style&index=0&id=fd38edce&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fd38edce"]])

export default __exports__